export function preview(s, h) {
  const sz = s.size === "xl" ? "2.4rem" : s.size === "sm" ? "1rem" : "1.5rem";
  const fw = s.weight || "300";
  const ls =
    s.ls === "tight" ? "-.02em" : s.ls === "wide" ? ".15em" : s.ls === "ultra" ? ".35em" : ".04em";
  const p =
    s.pad === "sm"
      ? "1.2rem 2rem .4rem"
      : s.pad === "lg"
        ? "4.5rem 2rem 1.5rem"
        : "2.5rem 2rem .8rem";
  return `<div style="${h.ff}${h.fc}padding:${p};text-align:${s.align || "left"};"><h2 style="font-size:${sz};font-weight:${fw};letter-spacing:${ls};margin:0;">${h.E(s.text || "Heading")}</h2></div>`;
}
export function render(s, h) {
  const sz = s.size === "xl" ? "2.4rem" : s.size === "sm" ? "1rem" : "1.5rem";
  const fw = s.weight || "300";
  const ls =
    s.ls === "tight" ? "-.02em" : s.ls === "wide" ? ".15em" : s.ls === "ultra" ? ".35em" : ".04em";
  const p =
    s.pad === "sm"
      ? "1.2rem 2rem .4rem"
      : s.pad === "lg"
        ? "4.5rem 2rem 1.5rem"
        : "2.5rem 2rem .8rem";
  return `<div style="${h.ff}${h.fc}padding:${p};text-align:${s.align || "left"};"><h2${s.scramble === "yes" ? " data-scramble" : ""} style="font-size:${sz};font-weight:${fw};letter-spacing:${ls};margin:0;">${h.E(s.text || "")}</h2></div>`;
}
